import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import styles from "./YesNoToggle.module.css";

function CheckIcon(props) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 5L4 8L9 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ToggleOption({ label, checked, onSelect, disabled }) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      className={styles.toggleButton}
      onClick={onSelect}
      disabled={disabled}
    >
      <span
        className={classNames(styles.toggleCheckbox, {
          [styles.toggleCheckboxChecked]: checked,
        })}
      >
        {checked && <CheckIcon className={styles.checkIcon} />}
      </span>
      {label}
    </button>
  );
}

ToggleOption.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export function YesNoToggle({ className, label, value, onChange, disabled }) {
  return (
    <div className={classNames(styles.container, className)}>
      {label && <span className={styles.label}>{label}</span>}
      <div
        className={styles.options}
        role="radiogroup"
        aria-label={label || "Yes/No toggle"}
      >
        <ToggleOption
          label="Yes"
          checked={value === true}
          onSelect={() => onChange(true)}
          disabled={disabled}
        />
        <ToggleOption
          label="No"
          checked={value === false}
          onSelect={() => onChange(false)}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

YesNoToggle.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
